
<template>
  <nav class="relative flex flex-wrap items-center justify-between px-2 bg-blueGray-500">
    <div class="w-full mx-auto flex flex-wrap shadow-2xl items-center py-2 justify-between sm:mx-4">
      <div class="w-full relative flex justify-between place-items-center lg:w-auto px-2 lg:static lg:block lg:justify-start">
        <router-link to="/" class="text-sm leading-relaxed inline-block py-2 whitespace-nowrap uppercase">
          <div class="flex place-content-center ">
              <img width="24" height="24" src="./assets/logo.png" alt="Logo Helping Hands">
            <p class="text-base ml-1 font-medium text-gray-200">Helping hands</p>
          </div>
        </router-link>
        <div class="flex place-items-center">
        <button class="text-gray-400 text-sm hover:text-blue-500 focus:text-blue-500 cursor-pointer leading-none border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none" type="button" v-on:click="toggleNavbar()">
          Menu
        </button>
        </div>
      </div>
      <div v-bind:class="{'hidden': !showMenu, 'flex': showMenu}" class="lg:flex lg:flex-grow items-center mx-4">
        <ul class="flex flex-col lg:flex-row list-none mr-4 ml-auto">
          <li class="nav-item my-2">
            <router-link v-on:click="toggleNavbar()" class="text-gray-400 p-4 focus:bg-gray-800 focus:text-blue-500 hover:text-blue-400 text-base font-normal" to="/">Home</router-link>
          </li>
          <li class="nav-item my-2">
            <router-link v-on:click="toggleNavbar()" class="text-gray-400 p-4 focus:bg-gray-800 focus:text-blue-500 hover:text-blue-400 text-base" to="/about">About</router-link>
          </li>
          <li class="nav-item my-2">
           <router-link v-on:click="toggleNavbar()" class="text-gray-400 p-4 focus:bg-gray-800 focus:text-blue-500 hover:text-blue-400 text-base" to='/disclaimer'> Disclaimer </router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="fixed bottom-6 rounded-full z-10 right-6">
      <router-link to="/addresource">
        <button class="text-gray-900">
          <svg class="fill-current hover:text-blue-200 text-blue-500 " width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 0C10.3008 0.0446294 6.76575 1.53395 4.14985 4.14985C1.53395 6.76575 0.0446294 10.3008 0 14C0.0446294 17.6992 1.53395 21.2343 4.14985 23.8501C6.76575 26.466 10.3008 27.9554 14 28C17.6992 27.9554 21.2343 26.466 23.8501 23.8501C26.466 21.2343 27.9554 17.6992 28 14C27.9554 10.3008 26.466 6.76575 23.8501 4.14985C21.2343 1.53395 17.6992 0.0446294 14 0ZM22 15H15V22H13V15H6V13H13V6H15V13H22V15Z" fill=""/>
          </svg>  </button>
        </router-link>
    </div>
  </nav>
  <router-view/>
  
</template>

<script >


export default {
  components:{
  },
  data() {
    return {
      showMenu: false,
    }
  },
  methods: {
    toggleNavbar: function(){
      this.showMenu = !this.showMenu;
    }
  }
}
</script>

